import { SingleEventHandler } from '@edreamsodigeo/frontend-core';
export const FARE_RULES_LOADED = 'frontend-shell:flexibility-bundle:loaded';
export const FARE_RULE_SELECT = 'frontend-shell:flexibility-bundle:onSelect';
export const NAVIGATE_TO_PAX = 'frontend-shell:flexibility-bundle:navigateToPax';
export const createfareRulesHandlers = () => ({
  onFareRulesLoaded() {
    window?.Odigeo?.trigger(FARE_RULES_LOADED);
  },
  onFareRuleSelect(fareRuleSelected) {
    window?.Odigeo?.trigger(FARE_RULE_SELECT, fareRuleSelected);
  },
  onNavigateToPax(forceReload) {
    window?.Odigeo?.trigger(NAVIGATE_TO_PAX, forceReload);
  },
  eventHandler: SingleEventHandler()
});